import axiosInstance from "../../api/axiosConfig";

// Endpoints públicos de auto-registro (sin auth).

const requestOtp = async (phone) => {
    const response = await axiosInstance.post(`/registro/request-otp`, { phone });
    return response.data;
};

const verifyOtp = async (phone, code) => {
    const response = await axiosInstance.post(`/registro/verify-otp`, { phone, code });
    return response.data; // { registrationToken }
};

const complete = async (data) => {
    const response = await axiosInstance.post(`/registro/complete`, data);
    return response.data; // { id, slug }
};

const RegistrationService = {
    requestOtp,
    verifyOtp,
    complete,
};

export default RegistrationService;
